import { RentFrom } from "./Promo";
import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { Minus, Plus, Lock } from "lucide-react";
import { Link } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import { fmt } from "../../mock";

const ProductDialog = ({ product, onClose }) => {
  const [qty, setQty] = useState(1);
  const { add, setOpen } = useCart();
  useEffect(() => setQty(1), [product]);
  if (!product) return null;
  const p = product;
  return (
    <Dialog open={!!product} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-[860px] p-0 overflow-hidden bg-white" data-testid="product-dialog">
        <div className="grid md:grid-cols-2">
          <div className="bg-[#f1f1f1] flex items-center justify-center p-6">
            <img src={(p.img || "").replace("w=600,h=340", "w=800,h=800")} alt={p.name} className="w-full max-h-[380px] object-contain" />
          </div>
          <div className="p-8 flex flex-col">
            {p.badge && <span className="self-start bg-[#1d1e20] text-white text-[11px] uppercase px-2.5 py-1 mb-3">{p.badge}</span>}
            <DialogTitle className="text-[26px] font-bold text-[#1d1e20] leading-tight">{p.name}</DialogTitle>
            <div className="text-[20px] mt-3 text-[#1d1e20]">
              {p.price_hidden ? <Link to="/area-clienti" onClick={onClose} className="inline-flex items-center gap-2 text-[15px] text-[#CF1072] hover:underline" data-testid="dialog-price-login"><Lock className="w-4 h-4" /> Accedi per vedere il prezzo</Link> : p.price == null ? <span className="text-[#56585e] text-[16px]">Prezzo su richiesta</span> : (
                <>
                  {p.old_price && <span className="line-through text-[#56585e] mr-3 text-[16px]">{fmt(p.old_price)}</span>}
                  <span className="font-bold text-[#CF1072]">{p.from_price ? "Da " : ""}{fmt(p.price)}</span>
                </>
              )}
            </div>
            <DialogDescription className="text-[15px] text-[#56585e] leading-relaxed mt-4">{p.description}</DialogDescription>
            {p.kind === "hardware" && <RentFrom p={p} onNavigate={onClose} />}
            {p.price_hidden ? (
              <Link to="/area-clienti" onClick={onClose} className="es-btn-primary h-[46px] mt-6 text-[15px]" data-testid="dialog-login-to-buy">Accedi o registrati per acquistare</Link>
            ) : p.price != null ? (
              <>
                <div className="flex items-center gap-3 mt-6">
                  <span className="text-[14px] text-[#1d1e20]">Quantità</span>
                  <div className="flex items-center border border-[#b8c0cc] rounded-full">
                    <button className="p-2 hover:text-[#CF1072]" onClick={() => setQty(Math.max(1, qty - 1))} data-testid="qty-minus"><Minus className="w-4 h-4" /></button>
                    <span className="w-8 text-center" data-testid="qty-value">{qty}</span>
                    <button className="p-2 hover:text-[#CF1072]" onClick={() => setQty(qty + 1)} data-testid="qty-plus"><Plus className="w-4 h-4" /></button>
                  </div>
                </div>
                <button
                  className="es-btn-primary h-[46px] mt-6 text-[15px]"
                  onClick={() => { add(p, qty); onClose(); setOpen(true); }}
                  data-testid="dialog-add-to-cart"
                >
                  Aggiungi al carrello
                </button>
              </>
            ) : (
              <button onClick={() => { onClose(); setTimeout(() => document.querySelector("#preventivo")?.scrollIntoView({ behavior: "smooth" }), 200); }} className="es-btn-primary h-[46px] mt-6 text-[15px]" data-testid="dialog-quote">Richiedi preventivo</button>
            )}
            <p className="text-[12px] text-[#56585e] mt-4">Spedizione e installazione disponibili in Campania. Assistenza 24/7 HelpVoice.</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ProductDialog;
